import r from "@brazilian-utils/helper-only-numbers";
import i from "@brazilian-utils/helper-is-last-char";
var e = 14,
    n = [1, 4],
    t = [7],
    u = [11];
export default function (l) {
  if (!l) return "";
  var a = r(l);
  return a.slice(0, e).split("").reduce(function (r, e, l) {
    var f = "" + r + e;

    if (!i(l, a)) {
      if (n.includes(l)) return f + ".";
      if (t.includes(l)) return f + "/";
      if (u.includes(l)) return f + "-";
    }

    return f;
  }, "");
}
;